import { MatDialogModule } from '@angular/material/dialog';
import { MatTableModule } from '@angular/material/table';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { FeatureUploadImportFilesModule } from '@unico-people/shared/dashboard/feature-upload-import-files';
import { EmployeeProcessingStatusRoutingModule } from './employee-processing-status-routing.module';
import { NgxPaginationModule } from 'ngx-pagination';

import { TopNavigationModule } from '../../components/top-navigation/top-navigation.module';
import { EmployeeProcessingStatusComponent } from './employee-processing-status.component';
import { FeaturePaginationModule } from '@unico-people/shared/dashboard/feature-pagination';
import { FeatureStatusErrorModule } from '@unico-people/shared/dashboard/feature-status-error';


@NgModule({
  declarations: [EmployeeProcessingStatusComponent],
  imports: [
    CommonModule,
    EmployeeProcessingStatusRoutingModule,
    TopNavigationModule,
    FeatureUploadImportFilesModule,
    MatDialogModule,
    MatTableModule,
    FeaturePaginationModule,
    NgxPaginationModule,
    FeatureStatusErrorModule
  ]
})
export class EmployeeStatusModule {}
